/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_AssessedInputs */

const en_directory_agent_readiness_assessed = /** @type {(inputs: Directory_Agent_Readiness_AssessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assessed`)
};

const zh_directory_agent_readiness_assessed = /** @type {(inputs: Directory_Agent_Readiness_AssessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评测时间`)
};

/**
* | output |
* | --- |
* | "Assessed" |
*
* @param {Directory_Agent_Readiness_AssessedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_assessed = /** @type {((inputs?: Directory_Agent_Readiness_AssessedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_AssessedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_assessed(inputs)
	return zh_directory_agent_readiness_assessed(inputs)
});
export { directory_agent_readiness_assessed as "directory.agent_readiness.assessed" }